import { paperRequest } from './paperClient';
// Ownership and expiry are established by the authenticated backend.
export const createPaperUploadSession = params => paperRequest('/api/paper-upload-sessions', params);
